import * as actions from "../constants/actionTypes";

const initialState = {
    loading: false,
    errors: [],
    displayAll: false,
    isDirty: false,
};

export default function defaultReducer(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOGGING_IN:
            newState.loading = true;
            break;

        case actions.LOGGED_IN:
            newState.loading = false;
            break;

        case actions.FAILED_LOG_IN:
            newState.loading = false;
            break;

        case actions.TOGGLE_DISPLAY_ALL_FILTER:
            newState.displayAll = action.payload;
            break;

        case actions.IS_DIRTY:
            newState.isDirty = true;
            break;

        case actions.IS_NOT_DIRTY:
            newState.isDirty = false;
            break;

        default:
            break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/default.js